"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../../actions");
const editableCampaign_1 = require("../../../../actions/editableCampaign");
const reducers_1 = require("../../../../reducers");
const PopoverModalForm_1 = require("../../components/PopoverModalForm");
const src_1 = require("@rover/ts-bootstrap/dist/src");
class EventSelection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSearchFocused: false,
            eventSearch: '',
        };
        this.getPopoverModalProps = this.getPopoverModalProps.bind(this);
        this.getPopoverFormInputProps = this.getPopoverFormInputProps.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.getPopoverNavbarProps = this.getPopoverNavbarProps.bind(this);
        this.getAddButton = this.getAddButton.bind(this);
        this.getEditButton = this.getEditButton.bind(this);
        this.getFilteredEvents = this.getFilteredEvents.bind(this);
        this.renderEvents = this.renderEvents.bind(this);
        this.closePopoverModal = this.closePopoverModal.bind(this);
    }
    getPopoverFormInputProps() {
        const { device, eventTrigger: { eventName }, } = this.props;
        return {
            id: 'automated-event-selection',
            label: 'Send notification when...',
            media: device,
            text: eventName,
            fieldStyle: {
                marginTop: 0,
                padding: device === 'Desktop' ? '24px 0 23px' : 0,
                minHeight: 'none',
                width: '100%',
            },
            isEditingText: false,
        };
    }
    getPopoverModalProps(handleClosePopoverModal) {
        return {
            placement: 'left',
            navBarProperties: Object.assign({ buttonLeft: 'Cancel', id: 'navBarId', style: {
                    containerStyle: {
                        borderRadius: '3px 3px 0px 0px',
                    },
                } }, this.getPopoverNavbarProps(handleClosePopoverModal)),
        };
    }
    getPopoverNavbarProps(handleClosePopoverModal) {
        return {
            buttonLeftCallback: () => {
                this.handleClose();
                handleClosePopoverModal();
            },
        };
    }
    handleClose() {
        this.setState({
            isSearchFocused: false,
            eventSearch: '',
        });
    }
    getAddButton() {
        const { device } = this.props;
        switch (device) {
            case 'Desktop':
                return (React.createElement("div", { key: "event-selection-add" },
                    React.createElement(src_1.Button, { text: "Select", type: "regular", style: {
                            innerStyle: {
                                fontSize: 17,
                            },
                            outerStyle: {
                                height: null,
                                lineHeight: '24px',
                            },
                        }, mouseDownColors: {
                            active: src_1.turquoise,
                            inactive: src_1.aquamarine,
                        } })));
            case 'Tablet':
                return React.createElement(src_1.PlusIcon, { key: "event-selection-add", fill: src_1.titanium });
            default:
                return null;
        }
    }
    getEditButton() {
        const { device } = this.props;
        switch (device) {
            case 'Desktop':
                return (React.createElement(src_1.Button, { text: "Change", type: "regular", style: {
                        innerStyle: {
                            fontSize: 17,
                        },
                    }, mouseDownColors: {
                        active: src_1.turquoise,
                        inactive: src_1.aquamarine,
                    }, key: "event-selection-change" }));
            case 'Tablet':
                return React.createElement(src_1.ChangeIcon, { key: "event-selection-change", fill: src_1.titanium });
            default:
                return null;
        }
    }
    getFilteredEvents() {
        const { events } = this.props;
        const { eventSearch } = this.state;
        return events
            .filter(({ namespace, name }) => {
            const search = eventSearch.toLowerCase();
            if (search === '') {
                return true;
            }
            return name.toLowerCase().includes(search) || (namespace || '').toLowerCase().includes(search);
        })
            .sort((a, b) => {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            if ((a.namespace || '') < (b.namespace || '')) {
                return -1;
            }
            if ((a.namespace || '') > (b.namespace || '')) {
                return 1;
            }
            return 0;
        });
    }
    closePopoverModal() {
        const { closePopoverModalForm, updateActivePopover, device } = this.props;
        closePopoverModalForm();
        setTimeout(() => updateActivePopover(''), device === 'Mobile' ? 500 : 0);
    }
    renderEvents() {
        const { device, eventTrigger, updateAutomatedEventTriggerEventName, updateAutomatedEventTriggerEventNamespace, updateEventTriggerFilters, } = this.props;
        const { eventName, eventNamespace } = eventTrigger;
        return (React.createElement("div", { style: {
                flex: '1 1 auto',
                paddingBottom: device === 'Mobile' ? 56 : 0,
            } },
            React.createElement(src_1.SelectableList, { device: device }, this.getFilteredEvents().map(({ name, namespace }, index) => (React.createElement("div", { key: index, onClick: (e) => {
                    e.stopPropagation();
                    if (!(eventName === name && eventNamespace === namespace)) {
                        updateAutomatedEventTriggerEventName(name);
                        updateAutomatedEventTriggerEventNamespace(namespace);
                        updateEventTriggerFilters({
                            __typename: 'EventAttributesEventTriggerFilter',
                            predicate: {
                                booleanOperator: 'OR',
                                predicates: [],
                            },
                        });
                    }
                    this.closePopoverModal();
                }, style: {
                    display: 'flex',
                    height: device !== 'Mobile' ? 55 : 71,
                    width: '100%',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                } },
                React.createElement(src_1.Text, { text: name, size: device === 'Mobile' ? 'large' : 'medium' }),
                React.createElement("div", { style: {
                        marginLeft: 10,
                        display: 'flex',
                        alignItems: 'flex-end',
                    } },
                    React.createElement(src_1.Text, { size: "small", text: namespace || '', textStyle: {
                            color: src_1.titanium,
                            marginRight: 8,
                        } }),
                    React.createElement(src_1.RadioButton, { selected: eventName === name && eventNamespace === namespace, style: {
                            outerStyle: { height: 18, width: 18 },
                        } }))))))));
    }
    render() {
        const { device } = this.props;
        const { isSearchFocused, eventSearch } = this.state;
        return (React.createElement(PopoverModalForm_1.default, { popoverFormInputProps: this.getPopoverFormInputProps(), presentationType: device !== 'Mobile' ? 'popover' : 'modal', field: "automated-event-selection", popoverModalProps: this.getPopoverModalProps, popoverNavbarProps: this.getPopoverNavbarProps, addButton: this.getAddButton(), editButton: this.getEditButton() },
            React.createElement("div", { style: {
                    width: device === 'Mobile' ? '100%' : 384,
                    height: device === 'Mobile' ? '100%' : 330,
                    display: 'flex',
                    flexDirection: 'column',
                } },
                React.createElement(src_1.PopoverSearch, { device: device, isSearchFocused: isSearchFocused, removeFocus: () => this.setState({ isSearchFocused: false }), setFocus: () => this.setState({ isSearchFocused: true }), submitText: (eventSearch) => this.setState({ eventSearch }), text: eventSearch }),
                React.createElement("div", { style: {
                        height: '100%',
                        overflowY: 'scroll',
                    } },
                    device === 'Mobile' && (React.createElement(src_1.Text, { size: "h1", text: "Send notification when...", textStyle: { margin: '24px 24px 8px 24px' } })),
                    this.renderEvents()))));
    }
}
const mapStateToProps = (state) => ({
    eventTrigger: reducers_1.getEditableCampaignEventTrigger(state),
    events: reducers_1.getEventSchemas(state),
});
const mapDispatchToProps = (dispatch) => {
    return {
        updateAutomatedEventTriggerEventName: (eventName) => {
            dispatch(actions_1.updateAutomatedEventTriggerEventName(eventName));
        },
        updateAutomatedEventTriggerEventNamespace: (eventNamespace) => {
            dispatch(actions_1.updateAutomatedEventTriggerEventNamespace(eventNamespace));
        },
        updateEventTriggerFilters: (f) => {
            dispatch(editableCampaign_1.updateEventTriggerFilters(f));
        },
        updateActivePopover: (field) => dispatch(actions_1.updateActivePopover(field)),
        closePopoverModalForm: () => dispatch(actions_1.closePopoverModalForm()),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(EventSelection);
